import { ImageWithFallback } from "@/components";
import { useFeatureFlag } from "configcat-react";
import { CONFIGCAT_KEYS } from "@/constants/configcat-keys";
import { PRIVATE_ROUTES } from "@/constants";
import { useMemo } from "react";

const Maintenance = () => {
  const { value: maintenance } = useFeatureFlag(
    CONFIGCAT_KEYS.MAINTENANCE,
    false,
  );

  const isMaintenance: boolean = useMemo(
    () => maintenance && PRIVATE_ROUTES.includes(window.location.pathname),
    [maintenance, window.location.pathname],
  );

  if (isMaintenance) {
    return (
      <div className="fixed flex items-center justify-center flex-col gap-12 bg-white/95 w-screen h-screen top-0 z-[9999999] select-none">
        <ImageWithFallback
          alt="Öğretmen Plus Bakım Modu"
          src="maintenance-dopi.svg"
        />
        <div className="text-center max-w-[784px] text-tp-text-500">
          <h1 className="font-bold text-4xl mb-5">Değerli Öğretmenimiz,</h1>
          <p className="font-normal text-lg mb-2">
            Öğretmen Plus yapay zeka destekli eğitim araçları yoğun talepten
            dolayı sırayla hizmet vermektedir. Birazdan tekrar denemeniz halinde
            sayfaya erişim sağlayabilirsiniz.😊
          </p>
          <p className="font-normal text-lg">
            Sabrınız ve anlayışınız için çok teşekkür ederiz! 💐
          </p>
        </div>
        <ImageWithFallback
          className="object-contain max-w-[166px] max-h-[44px]"
          alt="Öğretmen Plus Bakım Modu"
          src="logo.svg"
        />
      </div>
    );
  }

  return null;
};

export default Maintenance;
